export const ROLE_LABELS = {
  admin: "Administrator",
  office_staff: "Office Staff",
  instructor: "Instructor",
  parent: "Parent",
};

export const STATUS_STYLES = {
  scheduled: "bg-slate-100 text-slate-700 border-slate-200",
  confirmed: "bg-[hsl(var(--status-scheduled)/0.12)] text-[hsl(var(--status-scheduled))] border-[hsl(var(--status-scheduled)/0.3)]",
  in_progress: "bg-teal-50 text-teal-700 border-teal-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  no_show: "bg-rose-50 text-rose-700 border-rose-200",
  cancelled: "bg-zinc-100 text-zinc-700 border-zinc-200",
  rescheduled: "bg-amber-50 text-amber-800 border-amber-200",
  available: "bg-emerald-50 text-emerald-700 border-emerald-200",
  in_use: "bg-[hsl(var(--status-scheduled)/0.12)] text-[hsl(var(--status-scheduled))] border-[hsl(var(--status-scheduled)/0.3)]",
  maintenance: "bg-amber-50 text-amber-800 border-amber-200",
  open: "bg-rose-50 text-rose-700 border-rose-200",
  resolved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  refunded: "bg-zinc-100 text-zinc-700 border-zinc-200",
  pending: "bg-amber-50 text-amber-800 border-amber-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-rose-50 text-rose-700 border-rose-200",
  low: "bg-slate-100 text-slate-700 border-slate-200",
  medium: "bg-amber-50 text-amber-800 border-amber-200",
  high: "bg-rose-50 text-rose-700 border-rose-200",
};

export function formatDateTime(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatTime(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function statusLabel(status) {
  if (!status) return "";
  return status.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function initials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

// Splits a notification message into plain text + clickable link segments,
// so navigation links included in reminders are actually tappable instead
// of being inert text (reduces the need to copy/paste into a map app).
export function linkifySegments(text) {
  if (!text) return [];
  const parts = text.split(URL_REGEX);
  return parts.map((part, i) => {
    if (part.match(URL_REGEX)) {
      return { type: "link", key: i, href: part.replace(/[.,]$/, ""), text: part };
    }
    return { type: "text", key: i, text: part };
  });
}
